import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EgiAppQueries } from '@/app/platform/platform-data/queries/types';
import { EgiAppEntityStore } from '@/app/platform/platform-data/store/egi-app.entity.store';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

/**
 * Volgorde = die van de server. Onder Akita stond hier `sortBy: 'order'`, maar dat sorteerde
 * nooit: Akita vergeleek enkel eigen properties en `order` is een getter.
 */
@Injectable({ providedIn: 'root' })
export class EgiAppStoreQueries implements EgiAppQueries {
  constructor(protected store: EgiAppEntityStore) {}

  public all$ = this.store.selectAll();

  getAll(): EgiAppEntity[] {
    return this.store.getAll();
  }

  getHasCache(): boolean {
    return this.store.getHasCache();
  }

  public one$(id: string): Observable<EgiAppEntity> {
    return this.store.selectEntity(id);
  }

  isLoading$: Observable<boolean> = this.store.selectLoading();
  shouldBeSynced$: Observable<boolean> = this.store
    .selectAll()
    .pipe(map(apps => apps?.some(app => app.shouldBeSynced) ?? false));
}
